import { render, staticRenderFns } from "./insertCarData.vue?vue&type=template&id=30b8b2d5&scoped=true&"
import script from "./insertCarData.vue?vue&type=script&lang=js&"
export * from "./insertCarData.vue?vue&type=script&lang=js&"
import style0 from "./insertCarData.vue?vue&type=style&index=0&id=30b8b2d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8b2d5",
  null
  
)

export default component.exports